// src/components/charts/LineChart.jsx
import React from 'react';
import { AgCharts } from 'ag-charts-react';

/**
 * Componente LineChart con ag-Charts
 * @param {Object} props
 * @param {Array} props.data - Datos del gráfico
 * @param {String} props.xKey - Key para eje X
 * @param {Array} props.series - Series a mostrar
 * @param {String} props.title - Título del gráfico
 * @param {Number} props.height - Altura del gráfico (default: 400)
 */
const LineChart = ({
  data = [],
  xKey = 'date',
  series = [],
  title = '',
  height = 400,
}) => {
  const options = {
    data,
    title: title ? { text: title } : undefined,
    series: series.map((s) => ({
      type: 'line',
      xKey,
      yKey: s.yKey,
      yName: s.name || s.yKey,
      stroke: s.color || undefined,
      marker: {
        enabled: true,
        size: 6,
      },
    })),
    axes: [
      {
        type: 'category',
        position: 'bottom',
        title: {
          text: xKey,
        },
      },
      {
        type: 'number',
        position: 'left',
        title: {
          text: 'Valor',
        },
      },
    ],
    legend: {
      position: 'bottom',
    },
  };

  return (
    <div style={{ height }}>
      <AgCharts options={options} />
    </div>
  );
};

export default LineChart;